import React from 'react';
import {Slice} from '@reduxjs/toolkit';
import useLazyLoad from '../../../core/hooks/useLazyLoad';
import PaginationWrap from '../../atoms/PaginationWrap/PaginationWrap';
import LazyLoader from '../../atoms/UI/LazyLoader/LazyLoader';
import Grid from '../../molecules/Grid';
import ErrorWithReload from '../../molecules/ErrorWithReload/ErrorWithReload';

type GenericLazyLoadComponentProps = {
    slice: Slice;
    fetchAction: ((page: number) => any)
    renderItem: (item: any, index: number) => React.ReactNode;
};

const GenericLazyLoadComponent: React.FC<GenericLazyLoadComponentProps> = ({ slice, fetchAction, renderItem }) => {
    const {
        data: items,
        currentPage,
        isFetching,
        error,
        paginationRef
    } = useLazyLoad(slice, fetchAction);

    return (
        <PaginationWrap ref={paginationRef}>
            {isFetching && currentPage === 1 ? (
                <LazyLoader />
            ) : error ? (
                <ErrorWithReload error={error} />
            ) : (
                <Grid col='1' colDesktop='2' gap='2' gapDesktop='3' margin='3'>
                    {items.map((item, index) => renderItem(item, index))}
                </Grid>
            )}
            {isFetching && currentPage > 1 && <LazyLoader />}
        </PaginationWrap>
    );
};

export default GenericLazyLoadComponent;
